const CARD_TAG_ENUMS = {
  DIV: "div",
  LI: "li"
};
const CARD_SIZE_ENUMS = {
  MD: "md",
  LG: "lg"
};
export {
  CARD_SIZE_ENUMS,
  CARD_TAG_ENUMS
};
//# sourceMappingURL=constants.mjs.map
